export function FarmIcon() {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M20 21H17V19H20V21ZM20 17H17V15H20V17ZM20 13H17V11H20V13ZM24 7.8C23.6 4.5 20.8 2 17.5 2C15.8 2 14.1 2.7 12.9 3.9C12.2 4.6 11.7 5.3 11.4 6.2L15.6 9H22V22H24V7.8ZM13.3 7C13.9 5.2 15.6 4 17.5 4C19.4 4 21.1 5.2 21.7 7H13.3ZM7.5 6L0 11V22H15V11L7.5 6ZM13 20H10V14H5V20H2V12L7.5 8.5L13 12V20Z"
				fill="#7B809A"
			/>
		</svg>
	);
}
